export const RUNTIME_ENVIRONMENT = "prod";
// 'local' / 'prod'
